<template>
    <form
        @submit.prevent="form.post(route('checkout.step.summary.store'))"
        class="bg-white p-4 rounded-2xl shadow-lg"
    >
        <dl class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2">
            <div class="sm:col-span-1">
                <dt class="text-primary font-bold">Abholung</dt>
                <dd class="mt-1 text-gray-900 flex items-center">
                    <LogoutIcon class="text-primary h-5 w-5 mr-2" />
                    {{ formatDateTime(booking.start_time) }}
                </dd>
            </div>
            <div class="sm:col-span-1">
                <dt class="text-primary font-bold">Rückgabe</dt>
                <dd class="mt-1 text-gray-900 flex items-center">
                    <LoginIcon class="h-5 w-5 mr-2 text-primary" />
                    {{ formatDateTime(booking.end_time) }}
                </dd>
            </div>

            <div class="sm:col-span-1">
                <dt class="text-primary font-bold">Fahrzeug</dt>
                <dd class="mt-1 text-gray-900 flex items-center">
                    Opel Insignia
                </dd>
            </div>
            <div class="sm:col-span-1">
                <dt class="text-primary font-bold">Gesamtkilometer</dt>
                <dd class="mt-1 text-gray-900 flex items-center">
                    <CheckIcon class="h-5 w-5 mr-2 text-primary" />
                    {{ booking.km + booking.additional_km }} km, danach 0,35€/km
                </dd>
            </div>
            <div class="sm:col-span-1">
                <dt class="text-primary font-bold">Gesamtbetrag</dt>
                <dd class="mt-1 text-gray-900 flex items-center">
                    <CurrencyEuroIcon class="text-primary h-5 w-5 mr-2" />
                    {{
                        new Intl.NumberFormat("de-DE", {
                            style: "currency",
                            currency: "EUR",
                        }).format(booking.total_price)
                    }}
                </dd>
            </div>
            <div class="sm:col-span-1">
                <dt class="text-primary font-bold">Bezahlung</dt>
                <dd
                    class="mt-1 text-gray-900 flex items-center"
                    v-if="booking.initial_payment_method == 'total'"
                >
                    Gesamtbetrag per Vorkasse
                </dd>
                <dd
                    class="mt-1 text-gray-900 flex items-center"
                    v-else-if="booking.initial_payment_method == 'deposit'"
                >
                    Anzahlung
                </dd>
                <dd
                    class="mt-1 text-gray-900 flex items-center"
                    v-if="booking.initial_payment_method == 'cash'"
                >
                    Barzahlung
                </dd>
            </div>
            <div class="sm:col-span-1">
                <dt class="text-primary font-bold">Mieter</dt>
                <dd class="mt-1 text-gray-900 flex flex-col justify-center">
                    <span v-if="booking.company"
                        >{{ booking.company }}<br
                    /></span>
                    {{ booking.firstname }} {{ booking.lastname }}<br />
                    {{ booking.street }}<br />
                    {{ booking.zip }} {{ booking.city }}<br />
                    Tel: {{ booking.phone }}<br />
                    E-Mail: {{ booking.email }}<br />
                    Geburtsort: {{ booking.place_of_birth }}<br />
                    Geburtsdatum: {{ formatDate(booking.date_of_birth) }}<br />
                </dd>
            </div>
            <div class="sm:col-span-1">
                <dt class="text-primary font-bold">Weiterer Fahrer</dt>
                <dd
                    class="mt-1 text-gray-900 flex items-center"
                    v-if="booking.drivers[0]['firstname']"
                >
                    {{ booking.drivers[0]["firstname"] }}
                    {{ booking.drivers[0]["lastname"] }}<br />
                    {{ booking.drivers[0]["street"] }}<br />
                    {{ booking.drivers[0]["zip"] }}
                    {{ booking.drivers[0]["city"] }}<br />
                    Geburtsort: {{ booking.drivers[0]["place_of_birth"] }}<br />
                    Geburtsdatum:
                    {{ formatDate(booking.drivers[0]["date_of_birth"]) }}<br />
                </dd>
                <dd class="mt-1 text-gray-900 flex items-center" v-else>
                    Es wurden keine weiteren Fahrer angegeben.
                </dd>
            </div>
        </dl>

        <div class="mt-10 mb-2">
            <div class="relative flex items-center">
                <div class="flex items-center h-5">
                    <input
                        v-model="form.privacy_policy"
                        id="privacy_policy"
                        name="privacy_policy"
                        type="checkbox"
                        value="true"
                        class="focus:ring-primary h-4 w-4 text-primary border-primary border-opacity-30 rounded"
                    />
                </div>
                <div class="ml-3">
                    <label
                        for="privacy_policy"
                        class="font-medium text-primary-text"
                    >
                        Mit dem Abschluss der Reservierung bestätige ich, dass
                        ich die
                        <a
                            target="_blank"
                            href="/datenschutz"
                            class="text-primary"
                        >
                            Datenschutzbestimmungen
                        </a>
                        und die
                        <a target="_blank" href="/agmb" class="text-primary">
                            Allgemeinen Mietbedingungen
                        </a>

                        gelesen habe und diese akzeptiere.
                    </label>
                </div>
            </div>
        </div>

        <div class="mb-2">
            <div class="relative flex items-center">
                <div class="flex items-center h-5">
                    <input
                        v-model="form.bail"
                        id="bail"
                        name="bail"
                        type="checkbox"
                        value="true"
                        class="focus:ring-primary h-4 w-4 text-primary border-primary border-opacity-30 rounded"
                    />
                </div>
                <div class="ml-3">
                    <label for="bail" class="font-medium text-primary-text">
                        Ich bin damit einverstanden, dass ich bei Übernahme des
                        Fahrzeugs eine Kaution in Höhe von
                        {{ booking.bail }} Euro in bar leisten muss.
                    </label>
                </div>
            </div>
        </div>

        <div class="mb-5">
            <div class="relative flex items-center">
                <div class="flex items-center h-5">
                    <input
                        v-model="form.terms"
                        id="terms"
                        name="terms"
                        type="checkbox"
                        value="true"
                        class="focus:ring-primary h-4 w-4 text-primary border-primary border-opacity-30 rounded"
                    />
                </div>
                <div class="ml-3">
                    <label for="terms" class="font-medium text-primary-text">
                        Ich bin damit einverstanden, dass das Fahrzeug Vollkasko
                        versichert ist und eine Selbstbeteiligung von 1500,00 €
                        hat.
                    </label>
                </div>
            </div>
        </div>

        <small
            class="text-red-500 text-right"
            v-if="
                form.errors['bail'] ||
                form.errors['terms'] ||
                form.errors['privacy_policy']
            "
        >
            <strong>Akzeptieren Sie bitte die Checkboxes.</strong>
        </small>

        <div class="text-gray-700 text-sm font-light">
            Alle Preise inkl. der geltenden Mwst. Bitte beachten Sie, dass bei
            Ausnahmefällen ein gleichwertiges Fahrzeug bzw. Anhänger zur
            Verfügung gestellt wird. (Irrtum vorbehalten).
        </div>

        <div class="mt-5 flex justify-end">
            <button
                type="submit"
                :disabled="!form.privacy_policy || !form.terms || !form.bail"
            >
                <StyledButton
                    background-primary
                    :disabled="
                        !form.privacy_policy || !form.terms || !form.bail
                    "
                >
                    <div class="flex items-center">
                        Verbindlich buchen
                        <ArrowRightIcon class="h-5 w-5 ml-2" />
                    </div>
                </StyledButton>
            </button>
        </div>
    </form>
</template>
<script>
import {
    LogoutIcon,
    LoginIcon,
    CurrencyEuroIcon,
    CheckIcon,
    ArrowRightIcon,
} from "@heroicons/vue/outline";
import StyledButton from "@/Components/StyledButton.vue";

export default {
    components: {
        LogoutIcon,
        LoginIcon,
        CurrencyEuroIcon,
        CheckIcon,
        StyledButton,
        ArrowRightIcon,
    },

    props: {
        booking: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                privacy_policy: false,
                terms: false,
                bail: false,
            }),
        };
    },

    methods: {
        formatDateTime(date) {
            return new Date(date).toLocaleString("de-DE");
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString("de-DE");
        },
    },
};
</script>
